import Modal from 'components/Modal'
import UpdateStatus from 'views/MerchantProfile/Profile/UpdateStatus'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const Index = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <UpdateStatus onClose={onClose} />
    </Modal>
  )
}

export default Index
